var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXCircleFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3a13 13 0 1013 13A13.013 13.013 0 0016 3zm4.707 16.293a1 1 0 01-1.415 1.415L16 17.413l-3.293 3.293a1 1 0 01-1.415-1.415L14.587 16l-3.293-3.293a1 1 0 111.415-1.415L16 14.587l3.293-3.293a1 1 0 011.415 1.415L17.413 16l3.293 3.293z"
  })));
}
export default SvgXCircleFill;